import React from "react";
import { useTranslation } from "react-i18next";
import CommonButton from "../../Components/Button/CommonButton";
import CommonModal from "../../Components/Modal/CommonModal";

export default function CommonDeactivateModal({
  showDeactivateModal,
  setShowDeactivateModal,
  messageToShow = "Some warning...?",
  onConfirm,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <CommonModal
        showModal={showDeactivateModal}
        setShowModal={setShowDeactivateModal}
        
        modalTitle={t("Confirmation")}
        mainContent={
          <div className="pt-5 pb-[30px] flex justify-center items-center">
            <div>{messageToShow}</div>
          </div>
        }
        primaryActionButton={
          <>
            <CommonButton
              btnLabel={t("Deactivate")}
              colorType="danger"
              onClick={() => {
                onConfirm();
                setShowDeactivateModal(false);
              }}
            />
          </>
        }
        secondaryActionButton={
          <>
            <CommonButton
              btnLabel={t("Cancel")}
              onClick={() => setShowDeactivateModal(false)}
            />
          </>
        }
      />
    </div>
  );
}
